import { Box, Container, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

// Components
import TabComponent from 'src/components/Tab/TabComponent';
import DeviceManager from 'src/features/Setting/DeviceManager';
import Information from 'src/features/Setting/Information';
import Notification from 'src/features/Setting/Notification';
import Password from 'src/features/Setting/Password';
import PaymentHistory from 'src/features/Setting/PaymentHistory';
import PlanUsage from 'src/features/Setting/PlanUsage';
import InvoiceDetail from 'src/features/Setting/PaymentHistory/InvoiceDetail';
import { useQueryParam } from 'src/hooks/useQueryParam';

// Utilities
import { TABS_SETTING, TypeTabSetting } from 'src/features/Setting/config';
import { useSearchParams } from 'react-router-dom';
import { SectionErrorBoundary } from 'src/components/ErrorBoundary/SectionErrorBoundary';

const Setting = () => {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState<string>(TypeTabSetting.information as TypeTabSetting);
  const [, setSearchParam] = useSearchParams();

  const tab = useQueryParam('tab');
  const billingId = useQueryParam('billingId');

  useEffect(() => {
    if (tab) {
      setSelectedTab(tab);
    } else {
      setSelectedTab(TypeTabSetting.information);
    }
  }, [tab]);

  const renderForm = () => {
    switch (selectedTab) {
      case TypeTabSetting.information:
        return <Information />;
      case TypeTabSetting.notifications:
        return <Notification />;
      case TypeTabSetting.password:
        return <Password />;
      case TypeTabSetting.devices_manager:
        return <DeviceManager />;
      case TypeTabSetting.payment_history:
        return <PaymentHistory />;
      case TypeTabSetting.plan_usage:
        return <PlanUsage />;
      default:
        return <Information />;
    }
  };

  return (
    <Container
      maxWidth="xl"
      sx={{
        margin: '0px auto',
        py: 4,
      }}
    >
      <Box
        padding={4}
        sx={{
          background: theme.palette.background.default,
          borderRadius: theme.shape.borderRadius,
        }}
      >
        <Typography variant="h4">Account Settings</Typography>

        <Box sx={{ mt: 3.75 }} />

        <TabComponent
          tabs={TABS_SETTING}
          selected={selectedTab}
          handleChange={(e, value) => {
            setSelectedTab(value);
            setSearchParam();
          }}
        />

        <Box sx={{ mt: 3.75 }} />

        <SectionErrorBoundary resetKey={selectedTab} sectionName={`Setting-${selectedTab}`}>
          {renderForm()}
        </SectionErrorBoundary>
      </Box>

      {billingId && tab === TypeTabSetting.payment_history && <InvoiceDetail billingId={billingId} />}
    </Container>
  );
};

export default Setting;
